import { createThunkEffect } from "../../utilities/ActionUtility";
import * as InternalUserEffect from "./InternalUserEffect";

export const REQUEST_REGISTER_INTERNAL_USER = "UserRegistrationEffect.REQUEST_REGISTER_INTERNAL_USER";
export const REQUEST_REGISTER_INTERNAL_USER_FINISHED = "UserRegistrationEffect.REQUEST_REGISTER_INTERNAL_USER_FINISHED";

export const REQUEST_API_TOKEN_GENERATION = "InternalUserEffect.REQUEST_GENERATE_API_TOKEN_FOR_INTERNAL_USER";
export const REQUEST_API_TOKEN_GENERATION_FINISHED = "InternalUserEffect.REQUEST_GENERATE_API_TOKEN_FOR_INTERNAL_USER_FINISHED";

export const REQUEST_MARKETPLACE_TOKEN_GENERATION = "InternalUserEffect.REQUEST_MARKETPLACE_TOKEN_GENERATION";
export const REQUEST_MARKETPLACE_TOKEN_GENERATION_FINISHED = "InternalUserEffect.REQUEST_MARKETPLACE_TOKEN_GENERATION_FINISHED";


const createJSON = (details) => {
    return {
        username: details.sub,
        email: details.mail,
        firstName: details.given_name,
        lastName: details.family_name,
        phone: details.telephoneNumber,
        company: details.dbgEntity,
        country: details.country,
    };
};

export function registerInternalUser(decodedToken) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_REGISTER_INTERNAL_USER, InternalUserEffect.registerInternalUser, createJSON(decodedToken.user));
    };
}

export function generateApiTokenForInternalUser() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_API_TOKEN_GENERATION, InternalUserEffect.generateApiTokenForInternalUser);
    }
}

export function generateMarketplaceTokenForAdmin(marketplaceToken) {
    const request = {
        marketplaceToken: marketplaceToken
    }
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_MARKETPLACE_TOKEN_GENERATION, InternalUserEffect.generateMarketplaceTokenForAdmin, request);
    }
}